import React from "react";
import MdsSection from "../utilities/MdsSection";
import MdsRow from "../utilities/MdsRow";
import MdsCol from "../utilities/MdsCol";
import CustomImage from "../utilities/CustomImage";
import MotionSingle from "../utilities/Motion/MotionSingle";

const SingleImage = ({ slice }) => {
  const {
    primary: { image },
  } = slice;
  return (
    <MotionSingle amount={0.1} offsetY={100}>
      <MdsSection>
        <MdsRow>
          <MdsCol cols={12} className="grid place-items-center">
            <CustomImage image={image} />
          </MdsCol>
        </MdsRow>
      </MdsSection>
    </MotionSingle>
  );
};

export default SingleImage;
